module.exports = __webpack_public_path__ + "static/img/icon-warning.a815fcf3.png";